<div class="intro-section">
    <p class="intro-section__paragraph"
       [ngClass]="'intro-section__paragraph--' + (index + 1)"
       [ngStyle]="{'font-size': paragraph.fontSize ? pxToRem(paragraph.fontSize) + 'rem': '', 'line-height': paragraph.lineHeight ? pxToRem(paragraph.lineHeight) + 'rem' : ''}"
       *ngFor="let paragraph of data?.introSection?.paragraphs; let index = index">{{paragraph.copy}}</p>
</div>